// Third-party
import React from 'react';

type Props = {
  onClick: () => void;
  title: string;
  subtitle: string;
  icon: string;
};

const EmptyComparisonButton = (props: Props) => {
  const { title, subtitle, onClick, icon, ...rest } = props;

  return (
    <button type="button" className="empty-comparison-button d-flex align-items-center" onClick={onClick}>
      <img className="icon" src={icon} alt="" />
      <div className="flex-grow-1">
        <p className="title">{title}</p>
        <p className="subtitle">{subtitle}</p>
      </div>
      <i className="icon-cheveron-right" />
    </button>
  );
};

export default EmptyComparisonButton;
